/**
 * Ticket quota class that is part of the lottery
 */
export class TicketQuota {
  public '@id': string;
  public id: string;
  public submissionProcessSetup: string;
  public generalQuota: number;
  public activeMemberQuota: number;
  public customerAttributeConstraintItems: Array<AttributeConstraintItem> = [];

  constructor(ticketQuota: any) {
    this.id = ticketQuota.id;
    this['@id'] = ticketQuota['@id'];
    this.submissionProcessSetup = ticketQuota.submissionProcessSetup;
    this.generalQuota = ticketQuota.generalQuota;
    this.activeMemberQuota = ticketQuota.activeMemberQuota;
    for (const item of ticketQuota.customerAttributeConstraintItems) {
      this.customerAttributeConstraintItems.push(new AttributeConstraintItem(item));
    }
  }
}

/**
 * Class for all the attributes as constraint items
 */
export class AttributeConstraintItem {
  public id: string;
  public attributeName: string;
  public quota: number;

  constructor(attributeConstraints: any) {
    this.id = attributeConstraints.id;
    this.attributeName = attributeConstraints.attributeName;
    this.quota = attributeConstraints.quota;
  }
}
